<template>
  <b-card
    no-body
    class="pt-2"
  >
    <b-tabs
      pills
      nav-class="mx-2"
      lazy
    >
      <b-tab>
        <template #title>
          <FeatherIcon icon="ActivityIcon" />
          {{ $t('mySubtasks.tabs.open') }}
        </template>
        <my-subtasks-table status="open" />
      </b-tab>
      <b-tab>
        <template #title>
          <FeatherIcon icon="CheckCircleIcon" />
          {{ $t('mySubtasks.tabs.completed') }}
        </template>
        <my-subtasks-table status="completed" />
      </b-tab>
      <b-tab>
        <template #title>
          <FeatherIcon icon="XCircleIcon" />
          {{ $t('mySubtasks.tabs.cancelled') }}
        </template>
        <my-subtasks-table status="manager_cancelled" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BTabs, BTab } from 'bootstrap-vue'
import MySubtasksTable from '@/views/MySubtasks/Components/MySubtasksTable.vue'

export default {
  name: 'MySubtasksIndex',
  components: {
    BCard, BTabs, BTab, MySubtasksTable,
  },
}
</script>
